import React, { useEffect } from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import QuestionsStatus from "./QuestionsStatus";
import QuestionsMenu from "./QuestionsMenu";
import { useSelector, useDispatch } from "react-redux";
import { setLastQuestionId } from "../../../assets/redux/actions/Quiz";
import QuizRequests from "../../../assets/services/quiz";
import { useNavigate, useParams } from "react-router-dom";
// import AnswerQuestion from "../alertContents/AnswerQuestion";
import FinalizeMatchAlert from "../alertContents/FinalizeMatchAlert";
import CheatModal from "../alertContents/CheatDialog";
import MatchLoadingOverlay from "../LoadingOverlay";
import { getQuizType } from "../../../assets/utils/QuizType";

function Questions() {
  const { matchId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { lastQuestionId, finalize, loadingQuizReq } = useSelector(
    ({ quiz }) => quiz
  );

  useEffect(() => {
    if (!finalize) {
      dispatch(QuizRequests.getLastQuestionID(localStorage.getItem("Ticket")));
    }
    return () => {
      dispatch(setLastQuestionId(""));
    };
  }, [dispatch, finalize]);

  useEffect(() => {
    if (finalize) {
      dispatch(QuizRequests.finalizeAndGetReport(matchId));
      navigate("/match", { replace: true });
    }
  }, [dispatch, finalize]);

  useEffect(() => {
    if (lastQuestionId.id) {
      const searchParams = new URLSearchParams();
      searchParams.set("type", getQuizType(lastQuestionId.type));
      searchParams.set("qId", matchId);
      navigate(`/question/${lastQuestionId.id}?${searchParams.toString()}`);
    }
  }, [lastQuestionId, navigate]);

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <QuestionsStatus
          progressColor={"var(--alertColor)"}
          matchId={matchId}
        />
        <QuestionsMenu />
      </div>
      {/* <AnswerQuestion /> */}
      <FinalizeMatchAlert />
      <CheatModal />
      <MatchLoadingOverlay isActive={loadingQuizReq} />
    </AnimatedPageContainer>
  );
}

export default Questions;
